// ** React Imports
import { Fragment, useState, useEffect } from 'react'

// ** Dropdowns Imports
import UserDropdown from './UserDropdown'

// ** Third Party Components
import { Sun, Moon, Gitlab, ShoppingCart } from 'react-feather'

// ** Reactstrap Imports
import { NavItem, NavLink, Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap'
import MetamaskLogo from '../../../../assets/images/icons/metamask.svg'
import WalletConnect from '../../../../assets/images/icons/wallet-connect.svg'

import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { useWeb3React } from '@web3-react/core'

const NavbarUser = props => {


  const web3React = useWeb3React()
  const { account, error, isActive, chainId, provider } = useWeb3React()

  // ** Props
  const { skin, setSkin } = props
  const [showModel, setShowModel] = useState(false)
  const [isLoginLoading, setIsLoginLoading] = useState(false)
  // ** Function to toggle Theme (Light/Dark)


  // const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)

  useEffect(() => {
    // const accountData = JSON.parse(window.localStorage.getItem('account'))
    // if (accountData && accountData.isLogin) {
    //   setIsUserLoggedIn(true)
    // } else {
    //   setIsUserLoggedIn(false)
    // }
  }, [])

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  const toggleModal = () => {
    if (showModel) {
      setShowModel(false)
    } else {
      setShowModel(true)
    }
  }

  useEffect(() => {
    if (account) {
      setShowModel(false)
      const accountData = {
        accountAddress: account,
        isLogin: true,
        chainId
      }
      window.localStorage.setItem('account', JSON.stringify(accountData))
    } else {
      const accountData = {
        accountAddress: null,
        isLogin: false,
        chainId
      }
      window.localStorage.setItem('account', JSON.stringify(accountData))
    }
    if (error) {
      setShowModel(false)
    }
  }, [account, error, isActive, chainId, provider])

  const POLLING_INTERVAL = 3000
  const injected = new InjectedConnector({ supportedChainIds: [56, 97] })
  const wcConnector = new WalletConnectConnector({
    rpc: {
      56: "https://bsc-dataseed1.binance.org"
    },
    chainId: 56,
    network: "binance",
    qrcode: true,
    qrcodeModalOptions: {
      mobileLinks: [
        "metamask",
        "trust"
      ]
    },
    pollingInterval: POLLING_INTERVAL
  })

  wcConnector.networkId = 56

  const connectWithMetamask = async () => {
    try {
      setIsLoginLoading(true)
      await web3React.activate(injected)
      const loginPayload = {
        provider: 'injected',
        isLoggedIn: true
      }
      window.localStorage.setItem('userData', JSON.stringify(loginPayload))
    } catch (error) {
      const loginPayload = {
        provider: 'injected',
        isLoggedIn: false
      }
      window.localStorage.setItem('userData', JSON.stringify(loginPayload))
      console.error('error connecting to metamask ', error)
    } finally {
      setIsLoginLoading(false)
      setShowModel(false)
    }
  }

  const connectWithWalletConnect = async () => {

    try {
      setIsLoginLoading(true)
      await web3React.activate(wcConnector)
      const loginPayload = {
        provider: 'walletconnect',
        isLoggedIn: true
      }
      window.localStorage.setItem('userData', JSON.stringify(loginPayload))
    } catch (error) {
      const loginPayload = {
        provider: 'walletconnect',
        isLoggedIn: false
      }
      window.localStorage.setItem('userData', JSON.stringify(loginPayload))
      console.error('error connecting to wallet-connect ', error)
    } finally {
      setIsLoginLoading(false)
      setShowModel(false)
    }

  }
  return (
    <Fragment>
      <div className='bookmark-wrapper d-flex align-items-center'>
        <NavItem className='d-none d-lg-block'>
          <NavLink className='nav-link-style'>
            <ThemeToggler />
          </NavLink>
        </NavItem>
      </div>

      <ul className='nav navbar-nav align-items-center ms-auto'>
        <span>
          <Button.Ripple className='round' color='primary' outline size="sm" style={{ marginRight: '15px' }}>
            <a href='https://buy.ethfan.club/' target={'_blank'}>
              <span className='align-end ms-25'>Buy EFT</span>
              <ShoppingCart size={14} style={{ marginLeft: '5px' }} />
            </a>
          </Button.Ripple>
        </span>
        <span>

          {
            account ? (<div><UserDropdown /></div>) : (<Button.Ripple className='round' color='primary' outline size="sm" onClick={toggleModal}>
              <span className='align-middle ms-25'>Connect</span>
              <Gitlab size={14} style={{ marginLeft: '5px' }} />
            </Button.Ripple>)
          }
        </span>

        {/* <UserDropdown /> */}
      </ul>

      <Modal
        isOpen={showModel}
        toggle={() => toggleModal()}
        className='modal-dialog-centered'
      // modalClassName={item.modalColor}
      >
        <ModalHeader toggle={() => toggleModal()}>
          <div className="login-modal-title">Connect your wallet</div>
          <span className='build-version'>Build Version 1.0</span>
        </ModalHeader>
        <ModalBody className='login-model-body'>

          <div className='connector-select-container'>
            <div className='metamask-connector' onClick={connectWithMetamask}>
              {
                isLoginLoading ? (
                  <div className='metamask-login-btn'>
                    <Spinner type='grow' size='sm' style={{ margin: '5px' }} />
                  </div>
                ) : (
                  <div className='metamask-login-btn'>
                    <div className='logo'>
                      <img src={MetamaskLogo} alt="Login with metamask" />
                    </div>
                    <div className='value'>
                      Login with metamask
                    </div>
                  </div>
                )
              }
            </div>

            <div className='walletconnect-connector' onClick={connectWithWalletConnect}>
              {
                isLoginLoading ? (
                  <div className='walletconnect-login-btn'>
                    <Spinner type='grow' size='sm' style={{ margin: '5px' }} />
                  </div>
                ) : (
                  <div className='walletconnect-login-btn'>
                    <div className='logo'>
                      <img className="walletconnect-logo" src={WalletConnect} alt="Login with walletconnect" />
                    </div>
                    <div className='value'>
                      Login with walletconnect
                    </div>
                  </div>
                )
              }
            </div>
          </div>

        </ModalBody>

      </Modal>
    </Fragment>
  )
}
export default NavbarUser
